module.exports = require('../dist/selectors/mortgages');
